/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 20:35 VN — WEB-20261015-suzitee-related-wp
   Đã làm: thêm dòng LOẠI SP (xám) dưới tên trong card khối "More Items To Consider" (app Recomatic, PDP). App chưa bật dòng này
   (bật = đổi cài đặt app, ngoài phạm vi) nên đọc product type từ /products/<handle>.js (cache sessionStorage) và đổi chữ bằng bảng
   #sz-type-map do snippets/sz-type-label.liquid sinh ra (nguồn chung với Christmas). Không đụng dữ liệu SP/giá/app. */
(function () {
  "use strict";
  try {
    var root = document.querySelector(".shopify-block-recomatic-product");
    if (!root) return;
    var CK = "szr:type:v1", map = {}, cache = {}, inflight = {}, raf = 0;
    try { map = JSON.parse(document.getElementById("sz-type-map").textContent) || {}; } catch (e) {}
    try { cache = JSON.parse(sessionStorage.getItem(CK)) || {}; } catch (e) {}

    function typeOf(handle) {
      if (Object.prototype.hasOwnProperty.call(cache, handle)) return Promise.resolve(cache[handle]);
      if (inflight[handle]) return inflight[handle];
      inflight[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var t = p && typeof p.type === "string" ? p.type : "";
          if (p) { cache[handle] = t; try { sessionStorage.setItem(CK, JSON.stringify(cache)); } catch (e) {} }
          return t;
        })
        .catch(function () { return ""; });
      return inflight[handle];
    }

    function paint(card, type) {
      var attrs = card.querySelector(".recomatic-attributes");
      if (attrs && type) {
        var el = document.createElement("div");
        el.className = "szr-type";
        if (Object.prototype.hasOwnProperty.call(map, type)) el.innerHTML = map[type];
        else el.textContent = type;
        if (el.textContent) attrs.appendChild(el);
      }
      card.classList.add("szr-typed");
    }

    function scan() {
      var cards = root.querySelectorAll(".recomatic-product:not(.szr-typed)");
      for (var i = 0; i < cards.length; i++) {
        (function (c) {
          var h = c.getAttribute("data-handle");
          if (!h || c.__szr) return;
          c.__szr = 1;
          typeOf(h).then(function (t) { paint(c, t); });
        })(cards[i]);
      }
    }

    scan();
    var mo = new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; scan(); });
    });
    mo.observe(root, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  } catch (e) {}
})();

